/* eslint-disable hubspot-dev/no-default-react-imports */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreateNewList = ({
  nameValidationError,
  createListName,
  onListNameChange
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-ui-components.export.listModal.input-header"
    }),
    required: true,
    error: nameValidationError,
    validationMessage: nameValidationError ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-ui-components.export.listModal.nameError"
    }) : null,
    children: /*#__PURE__*/_jsx(TextInput, {
      value: createListName,
      onChange: onListNameChange,
      autoFocus: true
    })
  });
};
export default CreateNewList;